<template>
  <div class="main__search-field">
    <b-input-group>
      <template #prepend>
        <div class="input-group-prepend">
          <button class="bg-white" @click="genericSearch">
            <Tooltip text="Click search icon or press enter to search">
              <SearchIcon class="text-secondary" />
            </Tooltip>
          </button>
        </div>
      </template>
      <input
        id="searchElement"
        ref="filter"
        v-model="searchText"
        placeholder="Search"
        type="text"
        autocomplete="off"
        class="form-control"
        @keyup.enter="genericSearch"
      />
      <template #append>
        <div class="input-group-append d-flex">
          <button
            v-if="searchText.length > 0"
            class="mr-1 clear d-flex justify-content-center align-items-center clear-button"
            @click="clear"
          >
            x
          </button>
          <button id="tooltip-target-1" class="bg-white" @click="toggleShow">
            <mdicon name="tune-vertical" class="text-secondary" />
          </button>
        </div>
      </template>
    </b-input-group>
    <div class="col-12 position-relative bg-white p-0">
      <div v-show="show" id="country" class="position-absolute col-12 bg-white p-3 mt-2 rounded search-dropdown">
        <p class="mb-0 text-secondary">Filters</p>
        <div class="form-group col-12 p-0">
          <label class="d-inline col-4 p-0 mb-0">Country</label>
          <CountryPicker
            ref="country"
            class="col-8 p-0 country-field"
            name="Sender country"
            vid="country_code"
            placeholder="Country"
            @change="updateCountry"
            @select="searchByCountry"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { BInputGroup } from 'bootstrap-vue-next'
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { BY_COUNTRY, SEARCH } from '@/const/AssignmentListQueryFilters'
import { useAssignmentStore } from '@/store/assignment'
import Tooltip from '@/views/Components/Elements/Tooltip.vue'
import SearchIcon from '@/views/Components/Elements/Icons/SearchIcon.vue'
import CountryPicker from '@/views/Components/Elements/Form/CountryPicker.vue'

export default defineComponent({
  name: 'SearchFilter',
  components: {
    BInputGroup,
    CountryPicker,
    Tooltip,
    SearchIcon,
  },
  setup() {
    const searchText = ref<string>('')
    const country = ref<string>('')
    const show = ref<boolean>(false)
    const route = useRoute()
    const assignmentStore = useAssignmentStore()

    onMounted(() => {
      searchText.value = String(route.query[SEARCH] || '')
      country.value = String(route.query[BY_COUNTRY] || '')
    })

    const genericSearch = () => {
      assignmentStore.updateAssignmentsFilter({ [SEARCH]: searchText.value ? searchText.value : null })
    }

    const searchByCountry = () => {
      assignmentStore.updateAssignmentsFilter({ [BY_COUNTRY]: country.value ? country.value : null })
    }

    const clear = () => {
      country.value = ''
      searchText.value = ''
      show.value = false

      assignmentStore.updateAssignmentsFilter({
        [BY_COUNTRY]: null,
        [SEARCH]: null,
      })
    }

    const updateCountry = (e?: string) => {
      country.value = e || ''
      searchByCountry()
    }

    const toggleShow = () => {
      show.value = !show.value
    }

    return {
      searchText,
      country,
      show,
      clear,
      genericSearch,
      searchByCountry,
      updateCountry,
      toggleShow,
    }
  },
})
</script>
